import section1 from './pc/section1';
import section3 from './pc/section3';
import section4 from './pc/section4';



/*$(document).on('click', '.p-sec1__banner-item--2, .p-sec1__banner-item--3, .p-sec1__util-item--1, .p-sec2__link-item--1', function(e) {
    e.preventDefault();
    promokit.message({
        type: 'alert',
        message: '12. 23. Coming Soon!'
    });
});*/

$('.slide1').bxSlider({
    mode: 'fade',
    slideWidth: 1519,
    slideHeight: 864,
    controls: false,
    pager: true
});

$('.slide2').bxSlider({
    mode: 'fade',
    slideWidth: 1885,
    slideHeight: 1083,
    controls: false,
    pager: true
});

var video1 = promokit.youtube({
    el: '#player-1',
    youtubeid: '45Spqu4jNjg',
    loop: true,
    controls: true,
    mute: false
});

var layer1 = promokit.layer({
    el: '#layer-1',
    render: true,
    autoplayVideo: video1,
    buttons: '.p-sec1__btn-play'
});





let section2 = {
    id: '#section-2',
    name: '한눈에 보기'
};



promokit.preload({
    complete: function() {
        $('.p-sec1__btn-scroll').on('click', (e)=>{
            e.preventDefault();
            promokit.store('page').to(1);
        });
        $('.p-sec2__link-item--2').on('click', (e)=>{
            e.preventDefault();
            promokit.store('page').to(2);
        });
        $('.p-sec2__link-item--3').on('click', (e)=>{
            e.preventDefault();
            promokit.store('page').to(3);
        });
    }
});


promokit.page({
    type: 'fullpage-vertical',
    caution: '#section-caution',
    cnb: true, //true, false
    menu: true,
    topButton: true, //true, false
    footer: {
        fixed: true,
        theme: 'black' //'black', 'white'
    },
    headerButton: {
        el: '.header-button',
        cookie: {
            type: 'year', //'year', 'week', 'day'
            key: 'INDEX_WEB_VISIT_201214_update',
            value: false
        },
        home: true,
        event: false,
        update: true,
        sns: true,
        theme: 'black' //'black', 'white'
    },
    components: [
        section1,
        section2,
        section3,
        section4
    ],
})




// WEBPACK FOOTER //
// ./src/js/index.js